export interface PlayerServiceWsDTO {
  action: PlayerServiceCollectionAction;
  collection: string;
  data: any;
}

export enum PlayerServiceCollection {
  DUPLICATE_CHECKS = 'duplicate-checks',
  DOCUMENT_REQUESTS = 'document-requests',
}

export enum PlayerServiceCollectionAction {
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
  STATUS_CHANGED = 'STATUS_CHANGED',
  LOCKED = 'LOCKED',
  UNLOCKED = 'UNLOCKED',
  ARCHIVED = 'ARCHIVED',
}
